
import { transformObjectKeys } from "@core/utility/common-utils"
import { RecursiveSnakeCaseType, transformFromCamelCaseToSnakeCase, transformFromSnakeCaseToCamelCase } from "@core/utility/string-utils"
import { Observable, of, take } from "rxjs"

export let deleteUserLoad = (uiBody:DeleteUserUIRequestBody): Observable<DeleteUserAPIRequestBody>=>{

  let apiBody = new DeleteUserAPIRequestBody({data:transformObjectKeys(
    uiBody,
    transformFromCamelCaseToSnakeCase
  )})
  return of(apiBody)
  .pipe(
    take(1),
  )
}

export let deleteUserSuccess = (apiBody:DeleteUserAPIResponseBody):DeleteUserUIResponseBody=>{
  let uiBody = new DeleteUserUIResponseBody(transformObjectKeys(
    apiBody.data,
    transformFromSnakeCaseToCamelCase
  ))
  return uiBody
}

export class DeleteUserUIRequestBody {
  constructor(props:Partial<DeleteUserUIRequestBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  accessToken:string
  youtubeDataApiAccessToken:string
  googleDriveApiAccessToken:string
}

export class DeleteUserAPIRequestBody {
  constructor(props:Partial<DeleteUserAPIRequestBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )


  }
  data:RecursiveSnakeCaseType<DeleteUserUIRequestBody>

}

export class DeleteUserUIResponseBody{
  constructor(props:Partial<DeleteUserUIResponseBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }

}

export class DeleteUserAPIResponseBody {
  constructor(props:Partial<DeleteUserAPIResponseBody>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }
  data:RecursiveSnakeCaseType<DeleteUserUIResponseBody>
}

